import FormInput from './FormInput'

export { FormInput }

export default FormInput
